import React from 'react';
import { useDispatch } from 'react-redux';

import * as actions from '../../../store/actions/churgerBuilderActions';

export default function ChurgerControlItem(props) {
	const dispatch = useDispatch();

	const picDisplayFunc = () => {
		if (!props.pic) {
			return 'none';
		}
	};
	const picDisplay = picDisplayFunc();

	const labelDisplayFunc = () => {
		let label = props.label;
		let i = 0;
		let character = '';
		while (i <= label.length) {
			character = label.charAt(i);
			if (character === character.toUpperCase()) {
				return;
			} else {
				return 'none';
			}
		}
	};
	const labelDisplay = labelDisplayFunc();

	const inputDisplay =
		labelDisplay === 'none' &&
		props.label !== 'blank' &&
		props.label !== 'smolText'
			? ' '
			: 'none';

	const textareaDisplay = props.label === 'smolText' ? '' : 'none';

	const totalPriceDisplay = props.label === 'blank' ? '' : 'none';

	const changedHandler = (event) => {
		dispatch(actions.setMeme(props.label, event.target.value));
	};

	let cheeseHandler = () => {
		let cheese = prompt('Say cheese!');
		cheese = cheese !== null ? cheese.toLowerCase() : 'x';
		if (cheese.includes('cheese')) {
			dispatch(actions.addIngredient('cheese'));
			dispatch(actions.setFXPlaying('splatMoist'));
		} else {
			alert("That's not what I fukcing told you two do!! >:(");
		}
	};

	const more = props.label === 'Cheese' ? cheeseHandler : props.added;

	return (
		<div className="CControl">
			<div
				className="CCPic"
				style={{
					background: ` center / contain no-repeat url(${props.pic})`,
					display: picDisplay,
				}}
			></div>
			<div className="CCLabel" style={{ display: labelDisplay }}>
				{props.label}
			</div>
			<div>
				<input
					className="CCInput"
					style={{ display: inputDisplay }}
					placeholder={props.placeholder}
					onChange={changedHandler}
				/>
				<textarea
					className="CCTextarea"
					style={{ display: textareaDisplay }}
					placeholder={props.placeholder}
					onChange={changedHandler}
				/>
				<div style={{ display: totalPriceDisplay }}>
					Total: <h3 style={{ textAlign: 'center' }}>$45</h3>
				</div>
				<button
					className="CCBtn Less"
					onClick={props.removed}
					disabled={props.lessDisabled}
				>
					Oops!
				</button>
				<button
					className="CCBtn More"
					onClick={more}
					disabled={props.moreDisabled}
				>
					Add
				</button>
			</div>
		</div>
	);
}
